module.exports = __webpack_public_path__ + "static/media/05.8418cbfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/05.jpg
// module id = 695
// module chunks = 0